import { Injectable } from '@angular/core';

import {
  ListDistributionCenterRequest,
  ListDistributionCenterResponse,
  DistributionRequest,
  DistributionResponse,
  GetFileSignedUrlRequest,
  StatusType,
} from '../shared/api/gen_api_client/routing_pb';

import { v4 as uuidv4 } from 'uuid';
import * as grpcWeb from 'grpc-web';
import { ClientPointServiceClient, FileServiceClient } from '../shared/api/gen_api_client/RoutingServiceClientPb';
import { environment } from '../../../environments/environment';
import { GrpcFactoryService } from '../shared/sharedServices/grpc-factory.service';

@Injectable({
  providedIn: 'root',
})
export class CediStoreService {
  private hostUrlBack: string;
  private client: ClientPointServiceClient;
  private request: ListDistributionCenterRequest;
  private deletePointRequets: DistributionRequest;

  private fileService = this.grpcFactoryService.create(FileServiceClient, environment.hostnameMassive, 'FileServiceClient');
  private getFileSignedUrlCall = this.grpcFactoryService.call(this.fileService, this.fileService.getFileSignedUrl, {
    callName: 'getFileSignedUrl',
  });

  constructor(private grpcFactoryService: GrpcFactoryService) {
    this.hostUrlBack = environment.hostnameMassive;
    this.request = new ListDistributionCenterRequest();
    this.deletePointRequets = new DistributionRequest();
    this.client = new ClientPointServiceClient(this.hostUrlBack, {}, {});
  }

  async uploadFile(file: FormData) {
    try {
      const fileId = uuidv4();
      const request = new GetFileSignedUrlRequest();
      request.setFileid(fileId);
      const result = await this.getFileSignedUrlCall(request);
      const status = result?.getStatus();
      if (status?.getStatus() !== StatusType.SUCCESS) {
        throw status.getMessage();
      }
      const fileUrl = result.getSignedurl();
      await fetch(fileUrl, {
        method: 'POST',
        mode: 'cors',
        cache: 'default',
        body: file,
      });
      return fileId;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  getClientPointServiceAddress(companyId: number) {
    return new Promise((resolve, reject) => {
      this.request.setCompanyid(companyId);
      this.request.setShowstores(true);
      this.client.listDistributionCenter(this.request, {}, (err: grpcWeb.Error, response: ListDistributionCenterResponse) => {
        if (err) {
          return reject(err);
        }
        const clientPoints = response.getClientpointsList().map(point => {
          return {
            id: point.getId(),
            companyid: point.getCompanyid(),
            name: point.getName(),
            address: point.getAddress(),
            lat: point.getLat(),
            lng: point.getLat(),
            status: point.getStatus(),
            idcity: point.getIdcity(),
            namecity: point.getNamecity(),
            isdistributioncenter: point.getIsdistributioncenter(),
          };
        });
        resolve(clientPoints);
      });
    });
  }

  deleteClientPointServiceAddress(idAddress: number): Promise<string> {
    return new Promise((resolve, reject) => {
      this.deletePointRequets.setId(+idAddress);
      this.client.deleteDistributionCenter(this.deletePointRequets, {}, (err: grpcWeb.Error, response: DistributionResponse) => {
        if (err) {
          return reject(err);
        }
        const clientPoints = response.getResponse();
        resolve(clientPoints);
      });
    });
  }
}
